import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailClassStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [headcountData, setHeadcountData] = useState([]);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return { qtr: parseInt(qtr.replace("Q", "")), year: parseInt(year) };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getHeadcountData?qtr=${qtr}&year=${year}`
        );
        const current = res.data.current || [];
        setHeadcountData(current);
      } catch (err) {
        console.error("Failed to fetch headcount data", err);
      }
    };
    fetchData();
  }, [selectedQuarters]);

  const handlePrevious = () => {
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "class",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  // Overall totals
  const totalActive = headcountData.reduce(
    (sum, item) => sum + Number(item.active_class || 0),
    0
  );
  const totalDeferred = headcountData.reduce(
    (sum, item) => sum + Number(item.deferred || 0),
    0
  );
  const totalWithdrawn = headcountData.reduce(
    (sum, item) => sum + Number(item.withdrawn || 0),
    0
  );

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>
              Class Status Details (Active, Deferred, Withdrawn)
            </h4>
            <span style={pillStyle}>{selectedQuarters[0]}</span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          <table style={tableStyle}>
            <thead style={{ backgroundColor: "#000" }}>
              <tr>
                <th style={thStyle}>NO</th>
                <th style={thStyle}>COURSE CODE</th>
                <th style={thStyle}>COURSE LEVEL</th>
                <th style={thStyle}>STUDY MODE</th>
                <th style={thStyle}>FACULTY</th>
                <th style={thStyle}>SBU</th>
                <th style={thStyle}>ACTIVE</th>
                <th style={thStyle}>DEFERRED</th>
                <th style={thStyle}>WITHDRAWN</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                headcountData.reduce((acc, item) => {
                  const level = item.course_level || "Unknown Level";
                  if (!acc[level]) acc[level] = [];
                  acc[level].push(item);
                  return acc;
                }, {})
              )
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([level, courses], levelIdx) => {
                  const levelTotalActive = courses.reduce(
                    (sum, c) => sum + Number(c.active_class || 0),
                    0
                  );
                  const levelTotalDeferred = courses.reduce(
                    (sum, c) => sum + Number(c.deferred || 0),
                    0
                  );
                  const levelTotalWithdrawn = courses.reduce(
                    (sum, c) => sum + Number(c.withdrawn || 0),
                    0
                  );

                  return (
                    <React.Fragment key={levelIdx}>
                      <tr>
                        <td colSpan={9} style={groupHeaderStyle}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span>{level}</span>
                            <div style={{ display: "flex", gap: 8 }}>
                              <span style={pillHighlight}>
                                Active: {levelTotalActive}
                              </span>
                              <span style={pillHighlight}>
                                Deferred: {levelTotalDeferred}
                              </span>
                              <span style={pillHighlight}>
                                Withdrawn: {levelTotalWithdrawn}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      {courses.map((course, idx) => (
                        <tr
                          key={idx}
                          style={{
                            borderTop: "1px solid #444",
                            backgroundColor:
                              idx % 2 === 0 ? "#2b2b2b" : "#252525",
                          }}
                        >
                          <td style={tdStyle}>{idx + 1}</td>
                          <td style={tdStyle}>{course.course_code}</td>
                          <td style={tdStyle}>{course.course_level}</td>
                          <td style={tdStyle}>{course.study_mode}</td>
                          <td style={tdStyle}>{course.faculty_name}</td>
                          <td style={tdStyle}>{course.sbu_name}</td>
                          <td style={tdStyle}>{course.active_class}</td>
                          <td style={tdStyle}>{course.deferred}</td>
                          <td style={tdStyle}>{course.withdrawn}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  style={{ ...tdStyle, fontWeight: "bold", textAlign: "right" }}
                >
                  Total
                </td>
                <td style={{ ...tdStyle, fontWeight: "bold", color: "#f5b041" }}>
                  {totalActive}
                </td>
                <td style={{ ...tdStyle, fontWeight: "bold", color: "#f5b041" }}>
                  {totalDeferred}
                </td>
                <td style={{ ...tdStyle, fontWeight: "bold", color: "#f5b041" }}>
                  {totalWithdrawn}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  backgroundColor: "#1f1f1f",
  borderRadius: 6,
  overflow: "hidden",
};

const thStyle = {
  padding: "14px 12px",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};

const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
  textAlign: "center",
};

const groupHeaderStyle = {
  backgroundColor: "#111",
  fontWeight: "bold",
  color: "#fff",
  padding: "10px 12px",
  textAlign: "left",
};

const pillStyle = {
  background: "#444",
  padding: "6px 12px",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
};

const pillHighlight = {
  backgroundColor: "#f5b041",
  padding: "4px 10px",
  borderRadius: "999px",
  fontSize: 13,
  fontWeight: 500,
  color: "#000",
  minWidth: 50,
  textAlign: "center",
};

export default DetailClassStatus;
